/* =============================================================================
   Petcarestore.ca - custom JS
   Only one job: preload the hero slideshow images.
   Ella lazy-loads every banner, so slides 2 and 3 showed a blank panel for a
   moment the first time the carousel rotated to them. Nudging lazysizes to
   fetch them right after page load removes that flash. Fully guarded so a
   failure here can never affect the rest of the page.
   ============================================================================= */
(function () {
  function preloadHeroSlides() {
    try {
      var slideshow = document.querySelector('.slideshow');
      if (!slideshow) return;
      var imgs = slideshow.querySelectorAll('img.lazyload, img[data-srcset]');
      for (var i = 0; i < imgs.length && i < 8; i++) {
        imgs[i].classList.add('lazypreload');
      }
      if (window.lazySizes && typeof window.lazySizes.loader === 'object' &&
          typeof window.lazySizes.loader.checkElems === 'function') {
        window.lazySizes.loader.checkElems();
      }
    } catch (e) { /* never break the page over a preload */ }
  }

  if (document.readyState === 'complete') {
    setTimeout(preloadHeroSlides, 1200);
  } else {
    window.addEventListener('load', function () {
      setTimeout(preloadHeroSlides, 1200);
    });
  }
})();

/* =============================================================================
   Collection pages: the SEO copy runs to a couple of thousand characters and
   buried the first product row. custom.css clamps it to three lines; this adds
   the Read more / Read less control so the full text is still one click away
   (and stays in the DOM for search engines either way).
   ============================================================================= */
(function () {
  function addDescriptionToggle() {
    try {
      var blocks = document.querySelectorAll(
        '.articleLookbook-des, .collection-content .rte, .collection-description .rte');
      for (var i = 0; i < blocks.length; i++) {
        var rte = blocks[i];
        if (rte.dataset.pcsToggle) continue;
        // only worth a control when there is genuinely more to reveal
        if (rte.scrollHeight - rte.clientHeight < 24) continue;
        rte.dataset.pcsToggle = '1';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pcs-desc-more';
        btn.textContent = 'Read more';
        btn.setAttribute('aria-expanded', 'false');

        btn.addEventListener('click', function () {
          var open = rte.classList.toggle('pcs-desc-open');
          rte.style.webkitLineClamp = open ? 'unset' : '3';
          rte.style.display = open ? 'block' : '-webkit-box';
          btn.textContent = open ? 'Read less' : 'Read more';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        rte.parentNode.insertBefore(btn, rte.nextSibling);
      }
    } catch (e) { /* never break the page over a copy toggle */ }
  }

  if (document.readyState === 'complete') {
    setTimeout(addDescriptionToggle, 400);
  } else {
    window.addEventListener('load', function () { setTimeout(addDescriptionToggle, 400); });
  }
})();

/* =============================================================================
   Mega menu: append a "Shop all <category>" link to the bottom of each
   dropdown's link grid, pointing at the same collection as the top-level nav
   item. Purely additive and guarded; the dropdown works fine without it.
   ============================================================================= */
(function () {
  function addShopAllLinks() {
    try {
      var panels = document.querySelectorAll('.menu-lv-1.has-megamenu');
      for (var i = 0; i < panels.length; i++) {
        var li = panels[i];
        var column = li.querySelector('.menu-dropdown.megamenu_style_1 .menu-dropdown__column');
        if (!column || column.querySelector('.pcs-shop-all')) continue;

        var top = li.querySelector(':scope > a.menu-lv-1__action');
        if (!top) continue;
        var href = top.getAttribute('href');
        if (!href || href === '#') continue;

        var label = (top.querySelector('.text') || top).textContent.trim();
        if (!label) continue;

        var a = document.createElement('a');
        a.className = 'pcs-shop-all';
        a.href = href;
        a.textContent = 'Shop all ' + label.toLowerCase() + ' →';
        column.appendChild(a);
      }
    } catch (e) { /* the menu must never depend on this */ }
  }

  if (document.readyState === 'complete') {
    setTimeout(addShopAllLinks, 600);
  } else {
    window.addEventListener('load', function () { setTimeout(addShopAllLinks, 600); });
  }
})();
